module.exports = __webpack_public_path__ + "siteBanner_img_om.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/siteBanner_img_om.jpg
// module id = 1861
// module chunks = 0